import { Component } from '@angular/core';
import { ImplementChallengeComponent } from '../implement-challenge.component';

@Component({
  selector: 'app-implement-challenge-solution',
  templateUrl: './implement-challenge-solution.component.html',
  styleUrls: ['./implement-challenge-solution.component.scss']
})
export class ImplementChallengeSolutionComponent {

  constructor(public implementChallengeComponent: ImplementChallengeComponent) { }


}
